<ng-container *transloco="let t; read: 'orders'">
  <kendo-grid
    [data]="orders"
    [skip]="gridState.skip"
    [pageSize]="gridState.pageSize"
    [pageable]="true"
    (pageChange)="onPageChange($event)"
    [sortable]="{ allowUnsort: true }">


    <!-- DESKTOP GRID -->
    <kendo-grid-column 
      media="(min-width: 993px)"
      field="sequentialOrderNumber"
      [title]="t('orderNumber')"
      class="detailSpace">
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 993px)"
      field="internalOrderNumber"
      [title]="t('internalOrderNumber')">
    </kendo-grid-column>

    <kendo-grid-column 
      media="(min-width: 993px)"
      field="createdOn" 
      [title]="t('createdOn')">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.createdOn | date: 'dd.MM.yyyy' }}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column 
      media="(min-width: 993px)"
      field="company.name" 
      [title]="t('company')"
      [hidden]="!isAdminView">
    </kendo-grid-column>

    <kendo-grid-column 
      media="(min-width: 993px)"
      field="employee" 
      [title]="t('createdBy')">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.employee.firstName + ' ' + dataItem.employee.lastName }}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column 
      media="(min-width: 993px)"
      field="orderState" 
      [title]="t('orderState')">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{t('states.' + OrderStates[dataItem.orderState])}}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column 
      media="(min-width: 993px)"
      field="remarks" 
      [title]="t('remarks')">
    </kendo-grid-column>

    <kendo-grid-command-column
      media="(min-width: 993px)"
      [hidden]="!isAdminView">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button
          kendoButton
          class="buttonPrimary"
          [themeColor]="dataItem.orderState == OrderStates.open ? 'success' : 'warning'"
          (click)="onChangeOrderStateClick(dataItem)">
            {{ dataItem.orderState == OrderStates.open ? t('closeOrder') : t('reopenOrder') }}
        </button>
      </ng-template>
    </kendo-grid-command-column>
    

    <!-- MOBILE GRID -->
      <kendo-grid-column media="(max-width: 992px)">
        <ng-template kendoGridCellTemplate let-dataItem>
          <h4 class="mobileGridHeader">{{t('orderNumber')}}</h4>
          <span>{{dataItem.sequentialOrderNumber}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(max-width: 992px)">
        <ng-template kendoGridCellTemplate let-dataItem>
          <h4 class="mobileGridHeader">{{t('internalOrderNumber')}}</h4>
          <span>{{dataItem.internalOrderNumber}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(max-width: 992px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            <h4 class="mobileGridHeader">{{t('createdOn')}}</h4>
            <span>{{ dataItem.createdOn | date: 'dd.MM.yyyy' }}</span>
          </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(max-width: 992px)" [hidden]="!isAdminView">
        <ng-template kendoGridCellTemplate let-dataItem>
          <h4 class="mobileGridHeader">{{t('company')}}</h4>
          <span>{{dataItem.company.name}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(max-width: 992px)">
        <ng-template kendoGridCellTemplate let-dataItem>
          <h4 class="mobileGridHeader">{{t('createdBy')}}</h4>
          <span>{{ dataItem.employee.firstName + ' ' + dataItem.employee.lastName }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(max-width: 992px)">
        <ng-template kendoGridCellTemplate let-dataItem>
          <h4 class="mobileGridHeader">{{t('orderState')}}</h4>
          <span>{{t('states.' + OrderStates[dataItem.orderState])}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column media="(max-width: 992px)">
        <ng-template kendoGridCellTemplate let-dataItem>
          <h4 class="mobileGridHeader">{{t('remarks')}}</h4>
          <span>{{dataItem.remarks}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column media="(max-width: 992px)" [hidden]="!isAdminView">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button
            kendoButton
            class="buttonPrimary"
            [themeColor]="dataItem.orderState == OrderStates.open ? 'success' : 'warning'"
            (click)="onChangeOrderStateClick(dataItem)">
              {{ dataItem.orderState == OrderStates.open ? t('closeOrder') : t('reopenOrder') }}
          </button>
        </ng-template>
      </kendo-grid-command-column>

    <!-- FOOTER WITH PAGE CONTROL-->
    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate>
      <div class="flex gridPagination">
        <div class="flex flexDirRow gridRow">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
        </div>
        <div class="gridRow">
          <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
            <button
              (click)="onPageSizeChange(pageSizes.Small)"
              kendoButton
              [selected]="gridState.pageSize === pageSizes.Small"
              [toggleable]="true">
                {{ pageSizes.Small }}
            </button>
            <button
              (click)="onPageSizeChange(pageSizes.Medium)"
              kendoButton
              [selected]="gridState.pageSize === pageSizes.Medium"
              [toggleable]="true">
                {{ pageSizes.Medium }}
            </button>
            <button
              (click)="onPageSizeChange(pageSizes.Large)"
              kendoButton
              [selected]="gridState.pageSize === pageSizes.Large"
              [toggleable]="true">
                {{ pageSizes.Large }}
            </button>
          </kendo-buttongroup>

          <button
            kendoButton
            [title]="t('refresh')"
            (click)="onGridReload()"
            class="reloadIcon">
            <img class="actionIcon" src="../assets/icons/reload.svg">
          </button>
        </div>
      </div>
    </ng-template>


    <!-- IF NO RESULTS COULD BE FOUND -->
    <ng-template kendoGridNoRecordsTemplate>
      <div class="text pl">{{ t("noResults") }}</div>
    </ng-template>


    <!-- RENDER ORDER POSITIONS -->
    <ng-template kendoGridDetailTemplate let-dataItem>
      <app-order-positions 
        [orderPositions]="dataItem.orderPositions"
        class="subGrid">
      </app-order-positions>
    </ng-template>


  </kendo-grid>
</ng-container>
